import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["type"],
  _excluded2 = ["type"];
import React from 'react';
import { BulletedPoints } from '../BulletedPoints';
import { BulletedPointsList } from '../BulletedPointsList';
import { Countries } from '../Countries';
import { InfoLabelWithToolTip } from '../InfoLabelWithToolTip';
import { LinkButtonWithToolTip } from '../LinkButtonWithToolTip';
import { Range } from '../Range';
import { RichText } from '../RichText';
const BULLET_POINTS_MAX_COUNT = 3;
const BULLET_POINTS_LIST_MAX_COUNT = 2;
/**
 * Defines a set of RichComponent which can be used to render elements like text, link, tooltips etc.
 * This is the single source of truth for the UI part of QnAs
 * Check './README.md' to know more.
 */
// eslint-disable-next-line max-lines-per-function -- top-level component, necessary LoCs
export const RichComponent = props => {
  switch (props.type) {
    case 'text':
      return /*#__PURE__*/React.createElement(RichText, {
        items: [{
          type: 'text',
          text: props.text
        }]
      });
    case 'link':
      return /*#__PURE__*/React.createElement(RichText, {
        items: [{
          type: 'link',
          text: props.text,
          href: props.href
        }]
      });
    case 'link-with-icon':
      return /*#__PURE__*/React.createElement(RichText, {
        items: [{
          type: 'link-with-icon',
          text: props.text,
          href: props.href
        }]
      });
    case 'link-button-with-tooltip':
      return /*#__PURE__*/React.createElement(LinkButtonWithToolTip, {
        text: props.text,
        content: props.content
      });
    case 'info-label-with-tooltip':
      return /*#__PURE__*/React.createElement(InfoLabelWithToolTip, {
        text: props.text,
        content: props.content
      });
    case 'email':
      return /*#__PURE__*/React.createElement(RichText, {
        items: [{
          type: 'email',
          text: props.text,
          mailId: props.mailId
        }]
      });
    case 'rich-text':
      return /*#__PURE__*/React.createElement(RichText, {
        items: props.items
      });
    case 'bullet-points':
      {
        return /*#__PURE__*/React.createElement(BulletedPoints, {
          points: props.points,
          expandButton: {
            maxCount: BULLET_POINTS_MAX_COUNT,
            text: 'Expand all'
          }
        });
      }
    case 'bullet-points-list':
      {
        return /*#__PURE__*/React.createElement(BulletedPointsList, {
          bulletedList: props.bulletedList,
          expandButton: {
            maxListsCount: BULLET_POINTS_LIST_MAX_COUNT,
            maxCount: BULLET_POINTS_MAX_COUNT,
            text: 'Expand all'
          }
        });
      }
    case 'countries':
      {
        const {
            type
          } = props,
          countriesProps = _objectWithoutProperties(props, _excluded);
        return /*#__PURE__*/React.createElement(Countries, countriesProps);
      }
    case 'range':
      {
        const {
            type
          } = props,
          rangeProps = _objectWithoutProperties(props, _excluded2);
        return /*#__PURE__*/React.createElement(Range, rangeProps);
      }
    default:
      return null;
  }
};
export default RichComponent;